import { collection, getDocs, addDoc, query, orderBy, limit } from "firebase/firestore";
import { db } from "./firebase";

/**
 * Guarda una cotización en Firestore con ID incremental.
 * @param {Object} form - Datos del formulario
 * @param {Object} totales - Totales calculados
 * @param {Array} camposExtras - Campos adicionales del formulario
 * @returns {Promise<number>} número de cotización asignado
 */
export async function guardarCotizacionEnFirestore(form, totales, camposExtras) {
  try {
    // 1️⃣ Consultar el último número de cotización
    const q = query(collection(db, "cotizaciones"), orderBy("numCoti", "desc"), limit(1));
    const querySnapshot = await getDocs(q);

    let nuevoNumero = 1;
    if (!querySnapshot.empty) {
      const ultimo = querySnapshot.docs[0].data();
      nuevoNumero = (ultimo.numCoti || 0) + 1;
    }

    let nuevoNum = `CO_${nuevoNumero}`;

    // 2️⃣ Guardar la nueva cotización
    await addDoc(collection(db, "cotizaciones"), {
      numeroCotizacion: nuevoNum,
      numCoti: nuevoNumero,
      nombreCliente: form.nombreCliente,
      nombreProyecto: form.nombreProyecto,
      idCliente: form.idCliente,
      correoCliente: form.correoCliente,
      telefonoCliente: form.telefonoCliente,
      fecha: new Date(),
      totales,
      camposExtras,
    });

    console.log(`✅ Cotización guardada con ID #${nuevoNumero}`);
    return nuevoNum;
  } catch (error) {
    console.error("❌ Error al guardar cotización:", error);
    throw error;
  }
}